import {
  Platform,
  StyleSheet,
  Text,
  TouchableWithoutFeedback,
  View,
  ViewStyle,
} from "react-native";
import { Colors, Typography } from "../../styles";
import { FontAwesome5, Entypo } from "@expo/vector-icons";
import { useDispatch, useSelector } from "react-redux";
import { selectEntity, setBottomSheet } from "../../redux/mainSlice";
import { useNavigation } from "@react-navigation/native";
import { StackNavigationProp } from "@react-navigation/stack";
import { entityIcon } from "../../utils/data";

const ViewingEntity = ({ goBack = false }: { goBack?: boolean }) => {
  const dispatch = useDispatch();
  const navigation = useNavigation<StackNavigationProp<any>>();

  const entity = useSelector(selectEntity);

  return (
    <View style={styles.row}>
      {goBack && (
        <TouchableWithoutFeedback onPress={() => navigation.goBack()}>
          <Entypo name="chevron-small-left" size={24} color={Colors.white} />
        </TouchableWithoutFeedback>
      )}

      {/* Main */}
      <View style={styles.container}>
        <Text style={Typography.title}>How</Text>
        <TouchableWithoutFeedback
          onPress={() => dispatch(setBottomSheet("entities"))}
        >
          <View style={styles.entity}>
            <FontAwesome5
              name={entityIcon(entity)}
              size={14}
              color={Colors.white}
              style={styles.entityIcon}
            />
            <Text style={[Typography.title, styles.entityText]}>{entity}</Text>
          </View>
        </TouchableWithoutFeedback>

        <Text style={Typography.title}>sees Janette</Text>
      </View>

      {/* Spacer */}
      {goBack && <View style={{ width: 24 }} />}
    </View>
  );
};

const styles = StyleSheet.create({
  row: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: 20,
  },
  container: { flexDirection: "row" },
  entity: {
    paddingHorizontal: 3,
    marginHorizontal: 3,
    flexDirection: "row",
    alignItems: "center",
    borderBottomWidth: 1,
    borderColor: Colors.plum300,
    borderStyle: Platform.OS === "ios" ? "solid" : "dashed",
  },
  entityIcon: { marginTop: 2, marginRight: 4 },
  entityText: {
    // ...Typography.italic,
    textTransform: "capitalize",
    color: Colors.white,
  },
});

export default ViewingEntity;
